export default __webpack_public_path__ + "static/media/right-arrow.ca9af29d.svg";